import React from "react";
import "./into.css";
import GitHub from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import { FloatingDiv } from "../FloatingDiv/FloatingDiv";
import { themeContext } from "../../Context";
import { useContext } from "react";
import  {motion}  from "framer-motion";
import { Link } from "react-scroll";

export const Into = () => {
   const theme = useContext(themeContext);
   const darkMode = theme.state.darkMode;
   const transition = {
       duration: 3,
       repeat: Infinity,
       repeatType: "reverse",
   };
  return (
    <div className="into">
      <div className="i-left">
        <div className="i-name">
          <span style={{ color: darkMode ? "white" : "" }}>Hy! I Am</span>
          <span>Juan Camilo López</span>
          <span style={{ color: darkMode ? "white" : "" }}>
            <br />
            Information System Analysis and Development Technologist, passionate
            about analytical problem solving and solution creation.
            <br />I aspire to contribute to challenging projects and continue to
            expand my skills in the software development world.
          </span>
        </div>
        <Link spy={true} to="Contact" smooth={true} activeClass="activeClass">
          <button className=" button i-button">Hire me</button>
        </Link>
        <div className="i-icons">
          <a href="https://github.com/JuanCamiloLopez" target="black">
            <img src={GitHub} alt="GitHub" />
          </a>
          <a
            href="https://www.linkedin.com/in/juancamilolopezvelez/"
            target="black"
          >
            <img src={LinkedIn} alt="LinkedIn" />
          </a>
        </div>
      </div>
      <div className="i-right">
        <img alt="" />
        <img alt="" />
        <img alt="" />
        <img alt="" />
        <motion.div
          className="fdiv"
          initial={{ top: "2%", left: "50%" }}
          animate={{ left: "45%" }}
          transition={transition}
          style={{ top: "2%", left: "50%" }}
        >
          <FloatingDiv image={crown} txt1="Web" txt2="Developer" />
        </motion.div>
        <motion.div
          initial={{ top: "40%", left: "10%" }}
          whileInView={{ left: "20%" }}
          transition={transition}
          style={{ top: "40%", left: "10%" }}
          className="fdiv"
        >
          <FloatingDiv image={thumbup} txt1="DevOps and " txt2="Architecture" />
        </motion.div>
        {/* blur divs */}
        <div className="blur" style={{ background: "rgb(235 240 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "rgb(255 220 255)",
            top: "8rem",
            width: "22rem",
            height: "12rem",
            left: "8rem",
          }}
        ></div>
      </div>
    </div>
  );
};
